import type {
  VesselSearcherColumn,
  VesselSearcherFilterBounds,
  VesselSearcherFilters,
} from "../models/vessel-searcher.models";

export const VESSEL_SEARCHER_ALLOWED_SUBJECTS = [
  "ADRIAN_MOISA@CRGL-THIRDPARTY.COM",
  "Guilhem_Servet@cargill.com",
] as const;

export const VESSEL_SEARCHER_PAGE_SIZE = 100;

export const VESSEL_SEARCHER_FILTER_BOUNDS: VesselSearcherFilterBounds = {
  buildDate: { min: "1996-01", max: "2036-08" },
  dwt: { min: 501, max: 499125 },
  lbp: { min: 0, max: 473.6 },
  draft: { min: 0, max: 28 },
  depth: { min: 0, max: 75 },
  breadth: { min: 0, max: 123.75 },
};

export const VESSEL_SEARCHER_DEFAULT_FILTERS: VesselSearcherFilters = {
  imo: "",
  vesselName: "",
  useScrubber: "all",
  hasVoyageInImos: "all",
  buildDateFrom: "",
  buildDateTo: "",
  dwt: { min: "", max: "" },
  lbp: { min: "", max: "" },
  draft: { min: "", max: "" },
  depth: { min: "", max: "" },
  breadth: { min: "", max: "" },
  engineTypes: [],
  designs: [],
  yards: [],
  countries: [],
};

export const VESSEL_SEARCHER_COLUMNS: VesselSearcherColumn[] = [
  { key: "imo", label: "IMO" },
  { key: "vesselName", label: "Vessel name" },
  { key: "buildDate", label: "Build date" },
  { key: "keelLaidDate", label: "Keel laid date" },
  { key: "dwt", label: "DWT", alignRight: true },
  { key: "design", label: "Design" },
  { key: "yard", label: "Yard", wrap: true },
  { key: "country", label: "Country" },
  { key: "engineType", label: "Engine type" },
  { key: "lastInspection", label: "Last inspection" },
  { key: "useScrubber", label: "Use scrubber" },
  { key: "lastFixtureDate", label: "Last Fixture Date" },
  { key: "mcrIhs", label: "MCR IHS", alignRight: true },
  { key: "engineBuilder", label: "Engine builder", wrap: true },
  { key: "lbp", label: "LBP", alignRight: true },
  { key: "breadth", label: "Breadth", alignRight: true },
  { key: "depth", label: "Depth", alignRight: true },
  { key: "draft", label: "Draft", alignRight: true },
  { key: "eexi", label: "EEXI", alignRight: true },
  { key: "evdi", label: "EVDI", alignRight: true },
  { key: "ghgType", label: "GHG type" },
  { key: "hasVoyageInImos", label: "Has voyage in IMOS" },
];
